import type { FirebaseOptions } from '@firebase/app';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth, initializeRecaptchaConfig } from 'firebase/auth';

import { getErrorMessage } from '../utils/errors';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const { VITE_FIREBASE_CONFIG, VITE_RECAPTCHA_SITE_KEY } = import.meta.env;

let config: FirebaseOptions = {
  apiKey: 'AIzaSyCiD65koXhtncDwDUf--EkteCLWOoJToCc',
  authDomain: window.location.host,
  projectId: 'crowncoinscasino-4a9d7',
  storageBucket: 'crowncoinscasino-4a9d7.appspot.com',
  messagingSenderId: '921668979741',
  appId: '1:921668979741:web:7510ff61cb70cd1a450af4',
  measurementId: 'G-LRT39ZG844',
};

try {
  const parsed = JSON.parse(VITE_FIREBASE_CONFIG) as FirebaseOptions;
  if (parsed) {
    config = parsed;
  }
} catch (e) {
  const errorMessage = getErrorMessage(e);
  console.error(`Failed to parse VITE_FIREBASE_CONFIG: ${errorMessage}`);
}

export const firebase = initializeApp(config);

// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
initializeAppCheck(firebase, {
  provider: new ReCaptchaV3Provider(VITE_RECAPTCHA_SITE_KEY),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true,
});

// connectAuthEmulator(firebaseAuth, 'http://localhost:9099');

export const firebaseAuth = getAuth(firebase);

// Lazy reCAPTCHA Enterprise pre-warm — fetch the IDP recaptchaConfig + load
// enterprise.js so the user's first sign-in / sign-up call doesn't race the
// SDK's lazy script load (which manifests as MISSING_RECAPTCHA_TOKEN + an SDK
// auto-retry — works, but wastes a server round-trip and +1.5s latency).
//
// Lazy on purpose: reCAPTCHA Enterprise drops tracking cookies + a ~200KB
// script, so we load it only on auth screens (Login / Signup mount) or just
// before the auth call — not on every page that imports `firebaseAuth`.
let recaptchaReadyPromise: Promise<void> | null = null;
export function prewarmRecaptcha(): Promise<void> {
  if (!recaptchaReadyPromise) {
    recaptchaReadyPromise = initializeRecaptchaConfig(firebaseAuth).catch((e) => {
      console.warn('reCAPTCHA Enterprise pre-warm failed:', getErrorMessage(e));
    });
  }
  return recaptchaReadyPromise;
}

export const getFirebaseAuthToken = async () => {
  const token = await firebaseAuth.currentUser?.getIdToken();
  return token;
};

if (new URLSearchParams(window.location.search).has('__test')) {
  void firebaseAuth.setPersistence({ type: 'SESSION' });
}
